// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"DisplayInput_paragraph__3AhXe"};